import React, { FC, useState } from 'react';
import { Product } from '~/types/products';
import { Buttons } from '~/types/preamp';
import Button from '~/components/Button';
import { Check } from '../../../Icons/fill';
import { trackEvent } from '~/helpers/tracking';
import useWindowSize from '~/hooks/useWindowSize';
import { DEFAULT_FUSE_NUMBER } from '~/constants/config/common';
import { useSelector } from 'react-redux';
import { ReduxState } from '~/types/redux';

interface Props {
  name: string;
  index: number;
  product: Product;
  isCopper: boolean;
  callInNumber: string;
  handleSelectPlan?: (product: Product) => void;
  setSelectedCardIndex: (value: number) => void;
  buttons: Buttons;
  selectedPlan: boolean;
  featured: boolean;
}

const PlanCardCTAs: FC<Props> = ({
  name,
  index,
  product,
  isCopper,
  callInNumber,
  handleSelectPlan,
  buttons,
  selectedPlan,
  setSelectedCardIndex,
  featured
}) => {
  const isAllconnect = process.env.allconnect == 'true';
  const { mobile } = useWindowSize();
  const [btnHover, setButtonHover] = useState(false);
  const { address, products} = useSelector((store: ReduxState) => store);
  const netflixWith7Gig = products?.planPageSelections?.selectedNetflix && product?.is7Gig;

  const handleCallToOrder = () => {
    trackEvent({ action: 'callToOrder' });
    window.location.href = `tel:${DEFAULT_FUSE_NUMBER}`;
  };
  const state = address?.install?.state
  const agAddressType = (() => {
    if (['OH', 'PA', 'NV'].includes(state)) return 'ag-all';
    if (['MN'].includes(state)) return 'ag-mn';
    return 'ag-none';
  })();

  return (
    <div className={`plan-card__ctas${buttons?.call?.enabled === 'true' ? ' has-call-cta' : agAddressType === 'ag-mn' ? '__ag-mn' : ''}`}>
      <Button
        className={`plan-card__button${selectedPlan || featured ? ' active icon' : ''} ${netflixWith7Gig ? 'netflix-with-7gig' : ''}`}
        onClick={() => {
          setSelectedCardIndex(index);
          handleSelectPlan(product);
        }}
        data-testid="plan-card-btn-select"
        buttonConfig={buttons?.select}
        data-chsn-reward-click={!isCopper && `cart ${name?.toLocaleLowerCase()} plan card`}
        onMouseEnter={() => setButtonHover(true)}
        onMouseLeave={() => setButtonHover(false)}
        // Disable 7gig when netflix toggle is active
        disabled={netflixWith7Gig}
      >
        {selectedPlan ? (
          <span>
            <Check /> {buttons?.select?.activeText || 'Added to Cart'}
          </span>
        ) : netflixWith7Gig ? (
          'Unavailable with Netflix bundle' // Text when the product is 7Gig and Netflix toggle is active
        ) : btnHover ? (
          buttons?.select?.hoverText || 'Add to Cart' // Hover text
        ) : (
          buttons?.select?.text || 'Select Plan' // Default text
        )}
      </Button>

      {isAllconnect && mobile && buttons?.call?.enabled !== 'false' && (
        <Button
          as="a"
          href={`tel:${callInNumber}`}
          className="plan-card__button"
          secondary
          onClick={() => handleCallToOrder()}
          buttonConfig={buttons?.call}
        >
          {buttons?.call?.fuseNumber === 'true'
            ? `${callInNumber.replace(/-/g, '.')}`
            : buttons?.call?.text || 'Call to Order'}
        </Button>
      )}
    </div>
  );
};

PlanCardCTAs.displayName = 'PlanCardCTAs';

export default PlanCardCTAs;
